import React from "react";

/**
 * @멘션을 파싱하여 스타일이 적용된 React 요소로 변환
 * @param text 댓글 텍스트
 * @returns @멘션이 스타일링된 React 요소 배열
 */
export function renderTextWithMentions(text: string): React.ReactNode[] {
    // @username 패턴 매칭 (한글, 영문, 숫자, 일부 특수문자 허용)
    const mentionRegex = /@([가-힣a-zA-Z0-9_\-\.]+)/g;
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;
    let match;

    while ((match = mentionRegex.exec(text)) !== null) {
        const matchIndex = match.index;
        const username = match[1];

        // 멘션 이전의 일반 텍스트 추가
        if (matchIndex > lastIndex) {
            parts.push(text.substring(lastIndex, matchIndex));
        }

        // 멘션 추가 (스타일링 - ReplyInput과 동일)
        parts.push(
            <span
                key={`mention-${matchIndex}`}
                className="inline-flex items-center rounded-md bg-blue-100 px-2 py-0.5 text-sm font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-300"
            >
                @{username}
            </span>
        );

        lastIndex = matchIndex + match[0].length;
    }

    // 마지막 남은 텍스트 추가
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
    }

    return parts.length > 0 ? parts : [text];
}

/**
 * 텍스트에서 @멘션 목록 추출
 * @param text 댓글 텍스트
 * @returns 멘션된 사용자 이름 배열 (중복 제거)
 */
export function extractMentions(text: string): string[] {
    const mentionRegex = /@([가-힣a-zA-Z0-9_\-\.]+)/g;
    const mentions = new Set<string>();
    let match;

    while ((match = mentionRegex.exec(text)) !== null) {
        if (match[1]) {
            mentions.add(match[1]);
        }
    }

    return Array.from(mentions);
}
